export const randomId = (): string => Math.random().toString(36).substr(2, 5);
